'use client'

import Script from 'next/script'
import { useTermlyConsent } from './useTermlyConsent'

interface ConsentBasedGoogleAdsPixelProps {
  conversionId: string
  debug?: boolean
  // When true, skip rendering the gtag.js loader script. Set this when another
  // component (e.g. ConsentBasedGoogleAnalytics) has already injected the same
  // googletagmanager.com/gtag/js library — Google Ads only needs an additional
  // gtag('config', ...) call to register its container on the shared dataLayer.
  skipLoader?: boolean
}

export function ConsentBasedGoogleAdsPixel({
  conversionId,
  debug = false,
  skipLoader = false
}: ConsentBasedGoogleAdsPixelProps) {
  const hasConsent = useTermlyConsent(debug)

  if (!hasConsent) {
    return null
  }

  const safeConversionId = JSON.stringify(conversionId)

  return (
    <>
      {!skipLoader && (
        <Script
          id="google-ads-pixel-script"
          data-testid="google-ads-pixel-script"
          data-category="advertising"
          src={`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(conversionId)}`}
          strategy="afterInteractive"
        />
      )}
      <Script
        id="google-ads-pixel-config"
        data-testid="google-ads-pixel-config"
        data-category="advertising"
        strategy="afterInteractive"
      >
        {`
          window.dataLayer = window.dataLayer || [];
          if (typeof window.gtag !== 'function') {
            window.gtag = function(){window.dataLayer.push(arguments);};
          }
          window.gtag('js', new Date());
          window.gtag('config', ${safeConversionId});
        `}
      </Script>
    </>
  )
}

export default ConsentBasedGoogleAdsPixel
